module.exports = __tmimport("~endpoint:{controller: \'customized/api\', action: \'read_form\', event_id: \':event_id\'}");